import styles from "./style.module.scss";
import Image from "next/legacy/image";
import XIcon from "../xIcon";
import { useAtom } from "jotai";
import { comparisonVendors } from "@store/categoryStore";
import { GQLOffers } from "@gql/types/gql";
import { PLACE_HOLDER_IMAGE_PATH } from "@lib/sharedUtils";

export default function OneBuyerItem({ vendor }: { vendor: GQLOffers }) {
    const [, setComparisonList] = useAtom(comparisonVendors);
    const removeHandler = () => {
        setComparisonList((myList) =>
            myList.filter((el) => el.slug !== vendor.slug),
        );
    };
    return (
        <div className="relative">
            <div className={`${styles["oneBuyer"]} flex  justify-center`}>
                <div className=" flex  ">
                    {vendor.logo?.fullPath ? (
                        <Image
                            src={vendor.logo?.fullPath}
                            alt="logo"
                            width={90}
                            height={30}
                        />
                    ) : (
                        <>
                            <img
                                src={PLACE_HOLDER_IMAGE_PATH}
                                alt="logo"
                                width={90}
                                height={30}
                            />
                        </>
                    )}
                </div>
            </div>
            <span
                className="absolute -right-2 -top-2 cursor-pointer"
                onClick={removeHandler}
            >
                <XIcon />
            </span>
        </div>
    );
}
